import React from 'react';
import {useLocation} from 'react-router-dom';
import FooterItem from './item';

const Footer = ({menus, isFarm}: IFooterProps) => {
  const {pathname} = useLocation();
  return (
    <>
      <div className=" fixed bottom-0 w-full bg-white shadow-inner px-4 py-2 rounded-t-2xl -left-1">
        <div className="flex justify-around items-center relative">
          {React.Children.toArray(
            menus.map(item => (
              <>
                <FooterItem
                  role={item.role}
                  isMain={item?.isMain}
                  title={item?.title}
                  icon={item?.icon}
                  router={item?.route}
                  isActive={pathname.includes(item.route)}
                  main={item.main}
                  isFarm={isFarm}
                />
              </>
            )),
          )}
        </div>
      </div>
    </>
  );
};

export default Footer;
